import React, { useEffect, createElement } from 'react';
import { ScrollProgressBar } from './components/ScrollProgressBar';
import { StickyUrgencyBar } from './components/StickyUrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ScienceSection } from './components/ScienceSection';
import { ProductPresentation } from './components/ProductPresentation';
import { OfferStack } from './components/OfferStack';
import { ValueSummary } from './components/ValueSummary';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { FooterSection } from './components/FooterSection';
export function App() {
  useEffect(() => {
    // UTMify script
    const utmScript = document.createElement('script');
    utmScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmScript.setAttribute('data-utmify-prevent-subids', '');
    utmScript.async = true;
    utmScript.defer = true;
    document.head.appendChild(utmScript)
    // UTMify pixel
    ;
    (window as any).pixelId = '69a84f432f2498111cab00d3';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
    // Google tag (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-H6W0NPCL3K';
    document.head.appendChild(gtagScript);
    gtagScript.onload = () => {
      ;
      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(...args: any[]) {
        ;
        (window as any).dataLayer.push(args);
      }
      gtag('js', new Date());
      gtag('config', 'G-H6W0NPCL3K');
    };
    return () => {
      document.head.removeChild(utmScript);
      document.head.removeChild(pixelScript);
      document.head.removeChild(gtagScript);
    };
  }, []);
  return <div className="relative min-h-screen bg-crema selection:bg-verde/30" data-id="element-0">
      <ScrollProgressBar data-id="element-1" />
      <StickyUrgencyBar data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <ScienceSection data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <OfferStack data-id="element-8" />
        <ValueSummary data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <FooterSection data-id="element-14" />

      <StickyMobileCTA data-id="element-15" />
      <ExitIntentPopup data-id="element-16" />
    </div>;
}